module.exports = __webpack_public_path__ + "static/media/17.22c73e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/17.jpg
// module id = 707
// module chunks = 0